module.exports = {"410327100":"城关镇","410327102":"柳泉镇","410327103":"韩城镇","410327104":"白杨镇","410327105":"香鹿山镇","410327106":"锦屏镇","410327107":"三乡镇","410327108":"张坞镇","410327109":"莲庄镇","410327110":"赵保镇","410327111":"樊村镇","410327203":"盐镇乡","410327204":"高村乡","410327208":"花果山乡","410327209":"上观乡","410327212":"董王庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410327.json
// module id = 1422
// module chunks = 0